// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalInventoryLogs_root__Trii7","log":"ModalInventoryLogs_log__3KoQf","date":"ModalInventoryLogs_date__1if__","userName":"ModalInventoryLogs_userName__12fzi"};